export class ColorUtil {
	static SortColors (...colors) {
		const colorsMap = new Map();
		colors.forEach(color => {
			const numberValue = Number(color.replace("#", "0x"));
			colorsMap.set(color, numberValue);
			colorsMap.set(numberValue, color);
		});
		
		return Array.from(colorsMap.keys())
			.filter(key => Number.isSafeInteger(key))
			.toSorted((a, b) => a - b)
			.map(key => colorsMap.get(key));
	}
}